/** @format */

import React from 'react';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import convertDecimal from 'src/helpers/convertDecimal';

/* Controls used from controls/ */
import DropdownControl from './controls/DropdownControl';
import NumberControl from './controls/NumberControl';
import TextNumberControl from "./controls/TextNumberControl";
import PercentageControl from './controls/PercentageControl';
import CheckboxControl from './controls/CheckboxControl';
import ConsentControl from './controls/ConsentControl';
import DateControl from './controls/DateControl';
import CurrencyControl from './controls/CurrencyControl';
import RadioControl from './controls/RadioControl';
import FileUploadControl from './controls/FileUploadControl';
import ReadOnlyControl from './controls/ReadOnlyControl';
import CustomTextControl from './controls/CustomTextControl';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WPControl from './controls/WPControl';
import QuoteControl from './controls/QuoteControl';
import FileDownloadControl from './controls/FileDownloadControl/FileDownloadControl';
import DownloadControl from './controls/FileDownloadControl/DownloadControl';
import CaptionControl from './controls/Caption';
// import CrossCoreControl from './controls/CrossCoreControl';
const readOnlyExpection = ['WPVerticalTable', 'WPHorizontalTable'];
const ContentControls = {
  Caption: {
    fullWidth: true,
    ignoreFormValue: true,
    component: CaptionControl,
  },
  Header: {
    fullWidth: true,
    ignoreFormValue: true,
    component: props => {
      const labelText = transformDisplayText(props.label, DEFAULT_CONTROL_FONT_SIZES.Header, props.increaseFontSize);
      return (
        <h3 className={'control-caption header'}>
          {props.helpText ? <InfoTooltip toolTipText={props.helpText} labelText={labelText} /> : labelText}
        </h3>
      );
    },
  },
  DropDown: {
    component: DropdownControl,
    translateProps: (props, parserProps) => {
      return {
        lockAfterValueChange: props.lockAfterValueChange,
      };
    },
  },
  //   CrossCore: {
  //     component: CrossCoreControl,
  //     translateProps: (props, parserProps) => {
  //       return {
  //         lockAfterValueChange: props.lockAfterValueChange
  //       };
  //     }
  //   },
  CountryList: {
    component: DropdownControl,
    translateProps: (props, parserProps) => {
      return {
        lockAfterValueChange: props.lockAfterValueChange,
      };
    },
  },
  Consent: {
    component: ConsentControl,
    fullWidth: true,
    translateProps: (props, parserProps) => {
      return {
        label: undefined,
        displayText: props.displayText,
      };
    },
  },
  Radio: {
    component: RadioControl,
    translateProps: (props, parserProps) => {
      return {
        lockAfterValueChange: props.lockAfterValueChange,
      };
    },
  },
  Number: {
    component: NumberControl,
  },
  TextNumber: {
    component: TextNumberControl,
    translateProps: (props, parserProps) => {
      return {
        mask: props.mask,
      };
    },
  },
  Currency: {
    component: CurrencyControl,
    translateProps: props => {
      return {
        value: convertDecimal(props.value),
      };
    },
  },
  Percentage: {
    component: PercentageControl,
    translateProps: props => {
      return {
        value: convertDecimal(props.value),
      };
    },
  },
  CheckBox: {
    component: CheckboxControl,
    translateProps: (props, parserProps) => {
      return {
        lockAfterValueChange: props.lockAfterValueChange,
      };
    },
  },
  Textbox: {
    component: CustomTextControl,
    translateProps: (props, parserProps) => {
      return {
        mask: props.mask,
      };
    },
  },
  Date: {
    component: DateControl,
    translateProps: ({ from, to, defaultYear }) => ({ from, to, defaultYear }),
  },
  FileUpload: {
    component: FileUploadControl,
    fullWidth: true,
    includePageId: true,
    label: undefined,
  },
  ReadOnly: {
    component: ReadOnlyControl,
  },
  WP: {
    component: WPControl,
  },
  Quote: {
    component: QuoteControl,
    fullWidth: true,
  },
  FileDownload: {
    component: FileDownloadControl,
    translateProps: (props, parserProps) => {
      return {
        downloadPDFDocument: props.downloadPDFDocument,
      };
    },
  },
  DownloadButton: {
    component: DownloadControl,
    translateProps: (props, parserProps) => {
      return {
        downloadPDFDocument: props.downloadPDFDocument,
        action: props.action,
      };
    },
  },
};

function validateReadOnly(readOnly, controlTypeName, parentReadOnly) {
  return !parentReadOnly ? readOnlyExpection.includes(controlTypeName) : readOnly;
}

function translateToProps(data) {
  let {
    elementName: id,
    value,
    description,
    displayText: label,
    hasReadOnly: readOnly,
    mandatory: required,
    uploadedDocuments,
    multiline,
    from,
    to,
    defaultYear,
    reviewerOnly,
    superScript1,
    controlTypeName,
    readOnly: parentReadOnly,
  } = data;

  const controlProps = {
    id,
    label,
    name: id,
    readOnly: validateReadOnly(readOnly, controlTypeName, parentReadOnly),
    description,
    required,
    ...(uploadedDocuments ? { uploadedDocuments } : {}),
    value,
    multiline,
    from,
    to,
    ...(defaultYear ? { defaultYear } : {}),
    reviewerOnly,
    superScript: superScript1,
  };

  return controlProps;
}

function getContentControl(name, readOnlyControl = false, debug = false) {
  if (!ContentControls[name] && debug) {
    console.warn(`ContentParser: Unknown control type ${name}`);
    return null;
  }
  const controlName = readOnlyControl ? 'ReadOnly' : name;
  return ContentControls[controlName];
}

export { getContentControl, translateToProps };



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/ContentControls.js